import { createHttpApiClient } from './client';
import { createMockApiClient } from './mock';

const mockEnabled = import.meta.env.DEV && import.meta.env.VITE_ENABLE_API_MOCK === 'true';

export const api = mockEnabled
  ? createMockApiClient()
  : createHttpApiClient(import.meta.env.VITE_API_BASE_URL ?? '');

export * from './client';
export type * from './types';
